import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { NoData } from "../../../components/NoData";
import { Right } from "../../../components/styled";
import { useSelector } from "../../../store/hooks";
import { formatNumber } from "../../../utils/number";
import { BottomRow, BottomRowRightText } from "./RecommendationPanel";

export const ImplementationCostsEUR = () => {
  const { t } = useTranslation();
  const recommendation = useSelector(
    (s) => s.recommendationPanel.recommendation
  );
  const loadRecommendationStatus = useSelector(
    (s) => s.recommendationPanel.loadRecommendationStatus
  );
  const isLoading = loadRecommendationStatus === "loading";

  let render;
  if (isLoading) render = <Skeleton width={100} />;
  else if (!recommendation) render = <NoData />;
  else if (recommendation.implementationCostsEur === null) render = <NoData />;
  else
    render = (
      <BottomRowRightText>
        {formatNumber(recommendation.implementationCostsEur) + " €"}
      </BottomRowRightText>
    );

  return (
    <BottomRow>
      <Label>{t("ram.recommendationForm.implementationCostsEUR.label")}:</Label>
      <Right>{render}</Right>
    </BottomRow>
  );
};

const Label = styled.strong`
  color: ${(p) => p.theme.palette?.neutralPrimary};
`;
